import styled from 'styled-components';

export const StyledMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;
